/* @flow */

export default {
  strong: {
    // Add the correct font weight in Chrome, Edge, and Safari
    fontWeight: 'bolder',
  },
};
